var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"card",class:_vm.classes,attrs:{"to":{
        name: 'edition',
        params: {
            edition: _vm.edition.number,
            language: _vm.language,
            title: _vm.title
        }
    }}},[_c('div',{ref:"fit",staticClass:"cover"},[_c('visual',{attrs:{"src":_vm.cover}})],1),_c('div',{staticClass:"caption",style:(_vm.styles.caption)},[_c('heading',{attrs:{"level":5}},[_vm._v(_vm._s(_vm.surtitle))]),_c('heading',{attrs:{"level":2},domProps:{"innerHTML":_vm._s(_vm.edition.title)}}),_c('paragraph',{attrs:{"content":_vm.edition.excerpt,"size":_vm.$breakpoint.isS ? 'M' : 'S'}}),(!_vm.isActive)?_c('cta',{attrs:{"is-link":"","size":"M","font-icon":"fn_angleLink","type":"text","content":_vm.config.ctas.check}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }